import React from "react";
import {Button} from "reactstrap";

interface ToggleButtonProps {
    checked: boolean;
    loading?: boolean;
    onClick?: () => void;
    disabled?: boolean;
    size?: number;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
                                                       checked,
                                                       loading = false,
                                                       disabled = false,
                                                       onClick,
                                                       size = 32
                                                   }) => {
    const color = loading ? "secondary" : checked ? "success" : "danger";
    const icon = loading ? "mdi-loading mdi-spin" : checked ? "mdi-check" : "mdi-close-circle-outline";
    const title = loading ? "Updating..." : checked ? "Enabled" : "Disabled";

    return (
        <Button
            color={color}
            title={title}
            disabled={loading || disabled}
            onClick={onClick}
            className="p-0 d-inline-flex align-items-center justify-content-center"
            style={{width: size, height: size}}
        >
            <i className={`mdi ${icon} font-size-16`}></i>
        </Button>
    );
};

export default ToggleButton;